import { TriggerCodes } from 'services/suggestedMessages';

export enum Steps {
  THEME = 'THEME',
  TONE = 'TONE',
}

export const TriggersI18nKeys: Record<TriggerCodes, Record<string, string>> = {
  first_booking: {
    title: 'MESSAGETIPS.GLOBAL.FIRSTBOOKING',
    description: 'MESSAGETIPS.GLOBALSCHEDULED.FIRSTBOOKING',
  },
  completed_session_next_booking_incentive: {
    title: 'MESSAGETIPSV2.MENUDROPDOWN.REASONSESSIONCOMPLETED',
    description: 'MESSAGETIPSV2.GLOBALEDITMESSAGE.RULETOSEND',
    subtitle: 'MESSAGETIPSV2.GLOBALEDITMESSAGE.RULETOSENDSUBTITLE',
  },
  missed_session_next_booking_incentive: {
    title: 'MESSAGETIPSV2.MENUDROPDOWN.REASONSESSIOCANCELLED',
    description: 'MESSAGETIPSV2.GLOBALEDITMESSAGE.RULETOSEND',
    subtitle: 'MESSAGETIPSV2.GLOBALEDITMESSAGE.RULETOSENDSUBTITLE',
  },
};
